import { CheckOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { DeleteButton, EditButton, List, useTable } from "@refinedev/antd";
import { useApiUrl, useCustomMutation } from '@refinedev/core';
import { Space, Table } from "antd";
import React from 'react';

const to2 = num => num < 10 ? `0${num}` : `${num}`;

export const QBAuthList = () => {

	const { tableProps, tableQueryResult: { refetch }, } = useTable({
		resource: 'qbIES'
	});


	const {
        mutate: getQBLoginURI
    } = useCustomMutation();


    const API_URL = useApiUrl();

    const loginToQB = () => {

    	getQBLoginURI({
    		url: `${API_URL}/qbUsers`,
    		method: 'post',
    	},
    	{
    		onSuccess: (data, variables, context) => {

    			console.log({ data, variables, context });

	            let parameters = "location=1,width=800,height=650";
	            parameters += ",left=" + (window.screen.width - 800) / 2 + ",top=" + (window.screen.height - 650) / 2;
	            let win = window.open(data.data.authURL, 'connectPopup', parameters);
	            let pollOAuth = window.setInterval(function () {
	                try {
	                    if (win.document.URL.indexOf("code") != -1) {
	                        window.clearInterval(pollOAuth);
	                        win.close();
	                        refetch();
	                        window.location.reload();
	                    }
	                } catch (e) {
	                    console.log(e)
	                }
	            }, 100);

    		}
    	})

    }



	return (

		<List
			createButtonProps={{
                onClick: () => {
                    loginToQB();
                },
                children: 'Authorize Dealership'
            }}
		>

			<Table { ...tableProps } rowKey="id">

				<Table.Column dataIndex="id" title="ID" />
                <Table.Column dataIndex="company" title="Company" />
				<Table.Column dataIndex="isOnline" title="Status" render={ (value) => {
					if(!value) return <CloseCircleOutlined />
					else return <CheckOutlined />
				} } />
                <Table.Column dataIndex="updatedAt" title="Last refreshed access" render={ (value) => {
                	let date = new Date(value);
                	return `${ date.getFullYear() }-${ to2(date.getMonth() + 1) }-${ to2(date.getDate()) }  ${ to2(date.getHours()) }:${ to2(date.getMinutes()) }`
                }} />

                <Table.Column
                    title="Actions"
                    dataIndex="actions"

                    render={ (_text, record) => (

                        <Space>

                            <EditButton
                                size="small"
                                recordItemId={ record.id }
                                hideText
                                onClick={ () => 0 }
                            />

                            <DeleteButton 
                            	hideText
                            	recordItemId={ record.id }
                        	/>

                        </Space>

                    )}
                />

			</Table>


		</List>

	)

}